
/* Spineto Hogar - subtotal BCV del carrito lateral.
   Sin consultas a Odoo ni solicitudes adicionales. */
(function () {
  'use strict';

  function parseMoneyToCents(value) {
    var text = String(value || '').replace(/\u00a0/g, ' ');
    var matches = text.match(/[\d][\d.,\s]*[.,]\d{2}(?!\d)/g);
    if (!matches || !matches.length) return null;

    var amount = matches[matches.length - 1].trim();
    var separatorIndex = Math.max(
      amount.lastIndexOf(','),
      amount.lastIndexOf('.')
    );

    var units = amount.slice(0, separatorIndex).replace(/[^\d]/g, '');
    var decimals = amount.slice(separatorIndex + 1);

    if (!units || decimals.length !== 2) return null;

    var cents = Number(units) * 100 + Number(decimals);
    return Number.isSafeInteger(cents) ? cents : null;
  }

  function init() {
    var cart = document.querySelector('.quick-cart');
    if (!cart) return;

    var formatter = new Intl.NumberFormat('es-VE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    var scheduled = false;

    function update() {
      var subtotal = cart.querySelector(
        '.quick-cart__footer-subtotal .ff-product-price'
      );

      var ves = cart.querySelector(
        '.spineto-bcv-cart-subtotal[data-spineto-bcv-rate]'
      );

      if (!subtotal || !ves) return;

      var rate = Number(
        ves.getAttribute('data-spineto-bcv-rate')
      );

      var usdCents = parseMoneyToCents(subtotal.textContent);

      if (!Number.isFinite(rate) || rate <= 0 || usdCents === null) {
        return;
      }

      var vesCents = Math.round(usdCents * rate);
      var output = 'Bs. ' + formatter.format(vesCents / 100);

      if (ves.textContent.trim() !== output) {
        ves.textContent = output;
      }
    }

    function schedule() {
      if (scheduled) return;

      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        update();
      });
    }

    var observer = new MutationObserver(schedule);

    observer.observe(cart, {
      subtree: true,
      childList: true,
      characterData: true
    });

    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {
      once: true
    });
  } else {
    init();
  }
})();